<template>
    <div class="content">
        <div class="grid-container">
            <div class="personnel">
                <div class="personnel-hint">
                    <div class="hint-title">
                        <span>预约人数</span>
                    </div>
                    <div class="hint-info">
                        <span>{{ persionNumber.yuyueCount }}</span>
                    </div>
                </div>
                <div class="personnel-img">
                    <img src="@/assets/appraisal/Appointment.png" alt="">
                </div>
            </div>
            <div class="personnel">
                <div class="personnel-hint">
                    <div class="hint-title">
                        <span>预约签到人数</span>
                    </div>
                    <div class="hint-info">
                        <span>{{ persionNumber.yuyueqiandaoCount }}</span>
                    </div>
                </div>
                <div class="personnel-img">
                    <img src="@/assets/appraisal/SignIn.png" alt="">
                </div>
            </div>
            <div class="personnel">
                <div class="personnel-hint">
                    <div class="hint-title">
                        <span>临时签到人数</span>
                    </div>
                    <div class="hint-info">
                        <span>{{ persionNumber.linshiqiandaoCount }}</span>
                    </div>
                </div>
                <div class="personnel-img">
                    <img src="@/assets/appraisal/Temporary.png" alt="">
                </div>
            </div>
            <div class="personnel">
                <div class="personnel-hint">
                    <div class="hint-title">
                        <span>现场识别成功人数</span>
                    </div>
                    <div class="hint-info">
                        <span>{{ persionNumber.xianchangshibiechenggongCount }}</span>
                    </div>
                </div>
                <div class="personnel-img">
                    <img src="@/assets/appraisal/OnSite.png" alt="">
                </div>
            </div>
            <div class="personnel">
                <div class="personnel-hint">
                    <div class="hint-title">
                        <span>人工干预人数</span>
                    </div>
                    <div class="hint-info">
                        <span>{{ persionNumber.rengongganyuCount }}</span>
                    </div>
                </div>
                <div class="personnel-img">
                    <img src="@/assets/appraisal/Artificial.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import scaleMixin from '@/utils/scaleMixin.js'
    import {getselectHeader} from '@/api/industrialInjury/statistics.js'
    export default {
        name: 'statisticsHeader',
        mixins: [scaleMixin],
        data() {
            return {
                persionNumber:{}
            }
        },
        created() {
        },
        methods: {
            getselectHeaderInfo(data){
                getselectHeader(data).then(res=>{
                    if(res.code == 200){
                        this.persionNumber = res.data
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    height: 144px;
    
    .grid-container {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 20px; /* 设置间距 */
        width: 100%;
        height: 100%;
    }
    
    .personnel{
        width: 100%;
        height: 144px;
        background: var(--color-background-mute-soft);
        border: 1px solid var(--color-border-soft);
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-hint{
            display: flex;
            align-items: start;
            flex-direction: column;
            color: var(--vt-c-black);
            .hint-title{
             font-weight: var(--font-weight-bold);
             font-size: var( --font-size-large);
            }
            .hint-info{
             font-weight: var(--font-weight-normal);
             font-size: var( --fonte-size-big);
            }
        }
        &-img{
            width: 50px;
            height: 50px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>